import { render, staticRenderFns } from "./ImportHtml.vue?vue&type=template&id=5b15ba34&scoped=true&"
import script from "./ImportHtml.vue?vue&type=script&lang=js&"
export * from "./ImportHtml.vue?vue&type=script&lang=js&"
import style0 from "./ImportHtml.vue?vue&type=style&index=0&id=5b15ba34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b15ba34",
  null
  
)

export default component.exports